module.exports = __webpack_public_path__ + "static/img/1.0956215.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutUs/cpzl/1.jpg
// module id = hCUe
// module chunks = 0